document.addEventListener("DOMContentLoaded", () => {
  const isMobile = window.innerWidth <= 573;
  const layoutSection = isMobile
    ? document.getElementById("mobile-header")
    : document.getElementById("desktop-header");

  // Product-specific selectors (scoped)
  const imageContainer = layoutSection.querySelector(
    ".product-page-image-container"
  );
  const images = layoutSection.querySelectorAll(".product-page-image");
  const dots = layoutSection.querySelectorAll(".dot");
  const sizeSelector = layoutSection.querySelector("#size-selector");
  const addToCartButton = layoutSection.querySelector("#add-to-cart-button");
  const sizeSelectorButton = layoutSection.querySelector(
    ".size-selector-button"
  );
  let hasClickedSizeSelector = false;
  const sizeContainer = layoutSection.querySelector(
    ".product-page-size-selector"
  );

  // Global selectors (not scoped)
  const cartCounter = document.querySelector(".cart_counter");
  const cartWrapper = document.querySelector(".cart-wrapper");
  const cartItemsContainer = document.querySelector(
    ".cart-items-flex-container"
  );

  // Load product data from JSON
  let product = null;
  const productJson = document.querySelector('[id^="ProductJson-"]');
  if (productJson) {
    try {
      product = JSON.parse(productJson.textContent);
    } catch (e) {}
  }

  // Function to animate button text
  function animateButtonText(button, text, duration = 2000) {
    const originalText = button.textContent;
    button.textContent = text;
    button.classList.add("text-animation");
    setTimeout(() => {
      button.textContent = originalText;
      button.classList.remove("text-animation");
    }, duration);
  }

  // Check if variant is available
  function isVariantAvailable(variantId) {
    if (!product || !product.variants) return true;
    const variant = product.variants.find(
      (v) => v.id.toString() === variantId.toString()
    );
    return variant ? variant.available : false;
  }

  // Price Formatting
  function formatMoney(cents) {
    const currency = window.shopCurrency || "USD";
    if (window.moneyFormat) {
      const amount = cents / 100;
      if (window.moneyFormat.includes("{{amount}}")) {
        return window.moneyFormat.replace("{{amount}}", amount.toFixed(2));
      } else if (window.moneyFormat.includes("{{amount_no_decimals}}")) {
        return window.moneyFormat.replace(
          "{{amount_no_decimals}}",
          Math.round(amount).toString()
        );
      } else if (
        window.moneyFormat.includes("{{amount_with_comma_separator}}")
      ) {
        return window.moneyFormat.replace(
          "{{amount_with_comma_separator}}",
          amount.toFixed(2).replace(".", ",")
        );
      } else if (
        window.moneyFormat.includes("{{amount_with_space_separator}}")
      ) {
        return window.moneyFormat.replace(
          "{{amount_with_space_separator}}",
          amount.toFixed(2).replace(".", " ")
        );
      }
    }
    return new Intl.NumberFormat("en", {
      style: "currency",
      currency: currency,
    }).format(cents / 100);
  }

  // Sold out state
  if (addToCartButton && product && product.variants) {
    const allSoldOut = product.variants.every((v) => !v.available);
    if (allSoldOut) {
      addToCartButton.textContent = "Sold Out";
      addToCartButton.classList.add("loading");
      addToCartButton.style.pointerEvents = "none";
      addToCartButton.style.cssText += "cursor: default !important;";
    }
  }

  // Add to cart functionality
  if (addToCartButton) {
    addToCartButton.addEventListener("click", async function (e) {
      e.preventDefault();
      if (
        !sizeContainer?.classList.contains("one-size") &&
        !hasClickedSizeSelector
      ) {
        addToCartButton.classList.add("loading");
        addToCartButton.style.cssText += "cursor: default !important;";
        if (sizeSelectorButton) {
          sizeSelectorButton.style.pointerEvents = "none";
        }
        animateButtonText(addToCartButton, "Please Select a Size");
        setTimeout(() => {
          addToCartButton.classList.remove("loading");
          addToCartButton.style.cursor = "";
          if (sizeSelectorButton) {
            sizeSelectorButton.style.pointerEvents = "";
          }
        }, 2000);
        return;
      }

      // Get the variant ID
      let variantId;
      if (sizeSelector && sizeSelector.value) {
        variantId = sizeSelector.value;
      } else if (product && product.variants && product.variants.length > 0) {
        variantId = product.variants[0].id;
      } else {
        const variantInput = layoutSection.querySelector('input[name="id"]');
        if (variantInput) {
          variantId = variantInput.value;
        } else {
          const productForm = layoutSection.querySelector(
            'form[action*="/cart/add"]'
          );
          if (productForm && productForm.querySelector('[name="id"]')) {
            variantId = productForm.querySelector('[name="id"]').value;
          } else {
            animateButtonText(addToCartButton, "Product unavailable");
            return;
          }
        }
      }

      if (!isVariantAvailable(variantId)) {
        animateButtonText(addToCartButton, "Sold out");
        return;
      }

      try {
        const originalText = addToCartButton.textContent;
        addToCartButton.textContent = "Adding To Cart";
        addToCartButton.classList.add("loading");
        const response = await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            items: [{ id: variantId, quantity: 1 }],
          }),
        });
        const responseData = await response.json();
        if (response.status === 422 && responseData.description) {
          if (
            responseData.description.includes("not available") ||
            responseData.description.includes("maximum quantity")
          ) {
            addToCartButton.classList.remove("loading");
            const cartButtonText = "Add To Cart";
            addToCartButton.classList.add("loading");
            addToCartButton.style.cssText += "cursor: default !important;";
            addToCartButton.textContent = "Out of Stock";
            addToCartButton.classList.add("text-animation");
            setTimeout(() => {
              addToCartButton.classList.remove("loading");
              addToCartButton.classList.remove("text-animation");
              addToCartButton.style.cursor = "";
              addToCartButton.textContent = cartButtonText;
            }, 2000);
            return;
          }
        }

        // Get updated cart data
        const cartData = await (await fetch("/cart.js")).json();
        cartCounter.innerHTML = `<p>(</p>${cartData.item_count}<p>)</p>`;
        cartItemsContainer.innerHTML = "";
        cartData.items.forEach((item, index) => {
          for (let i = 0; i < item.quantity; i++) {
            let imageUrl = "";
            if (item.image) {
              imageUrl = item.image;
            } else if (item.featured_image && item.featured_image.url) {
              imageUrl = item.featured_image.url;
            } else {
              imageUrl = "";
            }
            const cartItemHTML = `
              <div class="cart-item-container" data-cart-item="${
                item.key
              }" data-line="${index + 1}">
                <div class="cart-image-container">
                  <img src="${imageUrl}" alt="${item.title || ""}">
                </div>
                <div class="cart-item-details-container">
                  <div class="cart-title-price-container">
                    <div class="cart-item-title">
                      ${item.product_title || item.title || ""}
                      <div class="cart-item-variant-title">
                        ${
                          item.variant_title &&
                          item.variant_title !== "Default Title"
                            ? `<p>(</p><p>${item.variant_title}</p><p>)</p>`
                            : ""
                        }
                      </div>
                    </div>
                    <div class="cart-item-price">${formatMoney(
                      item.price
                    )}</div>
                  </div>
                  <div class="cart-item-quantity-container">
                    <form class="remove-form" action="/cart/change" method="post">
                      <input type="hidden" name="id" value="${item.key}">
                      <input type="hidden" name="quantity" value="${
                        item.quantity - 1
                      }">
                      <button class="remove-button" data-remove-item>Remove</button>
                    </form>
                  </div>
                </div>
              </div>
            `;
            cartItemsContainer.innerHTML += cartItemHTML;
          }
        });

        addToCartButton.textContent = originalText;
        addToCartButton.classList.remove("loading");
        const totalContainer = cartWrapper.querySelector(
          ".cart-total-container span:last-child"
        );
        totalContainer.textContent = formatMoney(cartData.total_price);
        document.querySelector(".cart-toggle-button").click();
      } catch (error) {
        addToCartButton.textContent = "Add to Cart";
        addToCartButton.classList.remove("loading");
        animateButtonText(addToCartButton, "Error adding to cart");
      }
    });
  }

  // Size selector event
  if (sizeSelector && sizeSelectorButton) {
    sizeSelector.addEventListener("focus", handleSelectInteraction);
    sizeSelector.addEventListener("mousedown", handleSelectInteraction);
    sizeSelector.addEventListener("input", handleSelectInteraction);

    function handleSelectInteraction() {
      if (!hasClickedSizeSelector) {
        hasClickedSizeSelector = true;
        const firstOption = sizeSelector.options[0];
        const firstOptionText = firstOption.text.split(" - ")[0];
        const formattedText =
          firstOptionText.charAt(0).toUpperCase() +
          firstOptionText.slice(1).toLowerCase();
        sizeSelectorButton.textContent = formattedText;
        sizeSelectorButton.classList.add("uppercase");
      }
    }
  }

  if (sizeSelector) {
    sizeSelector.addEventListener("change", function () {
      const selectedOption = this.options[this.selectedIndex];
      if (selectedOption && sizeSelectorButton) {
        const selectedText = selectedOption.text.split(" - ")[0].trim();
        const formattedText =
          selectedText.charAt(0).toUpperCase() +
          selectedText.slice(1).toLowerCase();
        sizeSelectorButton.textContent = formattedText;
      }
    });
  }

  // dots

  const mobileDotsContainer = layoutSection.querySelector(
    ".mobile-product-image-dots"
  );
  const desktopDotsContainer = layoutSection.querySelector(
    ".product-page-left-dots"
  );

  if (images.length <= 1) {
    dots.forEach((dot) => (dot.style.display = "none"));
    if (mobileDotsContainer) mobileDotsContainer.style.display = "none";
    if (desktopDotsContainer) desktopDotsContainer.style.display = "none";
  }

  let mobileDotsTimeout;

  function showMobileDots() {
    if (!mobileDotsContainer) return;
    mobileDotsContainer.classList.add("visible");
    clearTimeout(mobileDotsTimeout);
    mobileDotsTimeout = setTimeout(() => {
      mobileDotsContainer.classList.remove("visible");
    }, 1000);
  }

  // Show dots initially on mobile
  if (isMobile && images.length > 1 && mobileDotsContainer) {
    showMobileDots();
  }

  // Show dots on scroll, then fade out after 1s
  if (isMobile && imageContainer && images.length > 1 && mobileDotsContainer) {
    imageContainer.addEventListener("scroll", () => {
      showMobileDots();
    });
  }

  if (dots[0]) dots[0].classList.add("active");

  dots.forEach((dot, index) => {
    dot.addEventListener("click", () => {
      const targetImage = images[index];
      if (targetImage && imageContainer) {
        if (isMobile) {
          imageContainer.scrollTo({
            left: targetImage.offsetLeft,
            behavior: "smooth",
          });
        } else {
          imageContainer.scrollTo({
            top: targetImage.offsetTop,
            behavior: "smooth",
          });
        }
      }
    });
  });

  if (imageContainer) {
    imageContainer.addEventListener("scroll", () => {
      let mostVisibleIndex = 0;
      let maxVisibility = 0;
      images.forEach((image, index) => {
        const rect = image.getBoundingClientRect();
        const containerRect = imageContainer.getBoundingClientRect();
        let visibility;
        if (isMobile) {
          const imageLeft = rect.left - containerRect.left;
          const imageWidth = rect.width;
          const containerWidth = imageContainer.clientWidth;
          const visibleWidth = Math.min(
            Math.max(
              0,
              Math.min(containerWidth, imageLeft + imageWidth) -
                Math.max(0, imageLeft)
            ),
            imageWidth
          );
          visibility = visibleWidth / imageWidth;
        } else {
          const imageTop = rect.top - containerRect.top;
          const imageHeight = rect.height;
          const containerHeight = imageContainer.clientHeight;
          const visibleHeight = Math.min(
            Math.max(
              0,
              Math.min(containerHeight, imageTop + imageHeight) -
                Math.max(0, imageTop)
            ),
            imageHeight
          );
          visibility = visibleHeight / imageHeight;
        }
        if (visibility > maxVisibility) {
          maxVisibility = visibility;
          mostVisibleIndex = index;
        }
      });
      dots.forEach((dot, idx) => {
        dot.classList.toggle("active", idx === mostVisibleIndex);
      });
    });
  }

  //expand
  const expandableSections = layoutSection.querySelectorAll(
    ".product-page-description"
  );
  expandableSections.forEach((section) => {
    if (section.querySelector(".div-title-expand-container")) {
      section.classList.add("collapsed");
      const icon = section.querySelector(".expand-icon");
      icon.dataset.rotation = "45";
      icon.style.transform = "rotate(45deg)";
      section.style.cursor = "pointer";
      section.addEventListener("click", (e) => {
        const initialHeight = section.offsetHeight;
        let scrollContainer =
          layoutSection.querySelector(
            ".product-page-right-information-container"
          ) ||
          layoutSection.querySelector(".mobile-product-description-container");
        const sectionTop =
          section.getBoundingClientRect().top -
          scrollContainer.getBoundingClientRect().top +
          scrollContainer.scrollTop;
        section.classList.toggle("collapsed");
        let currentRotation = parseInt(icon.dataset.rotation) || 45;
        let newRotation = currentRotation + 45;
        icon.dataset.rotation = newRotation.toString();
        icon.style.transition = "transform 0.3s ease";
        icon.style.transform = `rotate(${newRotation}deg)`;
        if (!section.classList.contains("collapsed")) {
          setTimeout(() => {
            const isMobile = window.innerWidth <= 573;
            if (isMobile) {
              section.scrollIntoView({ behavior: "smooth", block: "start" });
            } else {
              let scrollContainer =
                layoutSection.querySelector(
                  ".product-page-right-information-container"
                ) ||
                layoutSection.querySelector(
                  ".mobile-product-description-container"
                );
              const sectionTop =
                section.getBoundingClientRect().top -
                scrollContainer.getBoundingClientRect().top +
                scrollContainer.scrollTop;
              const newScrollTop = sectionTop - 25;
              smoothScrollTo(scrollContainer, newScrollTop, 1000);
            }
          }, 10);
        }
        function smoothScrollTo(element, to, duration) {
          const start = element.scrollTop;
          const change = to - start;
          let startTime = null;
          let userScrolled = false;
          const detectUserScroll = () => {
            userScrolled = true;
          };
          element.addEventListener("wheel", detectUserScroll, {
            passive: true,
          });
          element.addEventListener("touchmove", detectUserScroll, {
            passive: true,
          });
          function animation(currentTime) {
            if (userScrolled) {
              element.removeEventListener("wheel", detectUserScroll);
              element.removeEventListener("touchmove", detectUserScroll);
              return;
            }
            if (startTime === null) {
              startTime = currentTime;
            }
            const timeElapsed = currentTime - startTime;
            const progress = Math.min(timeElapsed / duration, 1);
            const eased = easeOutQuint(progress);
            element.scrollTop = start + change * eased;
            if (timeElapsed < duration) {
              element._scrollAnimation = requestAnimationFrame(animation);
            } else {
              element.removeEventListener("wheel", detectUserScroll);
              element.removeEventListener("touchmove", detectUserScroll);
              element.scrollTop = to;
            }
          }
          function easeOutQuint(t) {
            return 1 - Math.pow(1 - t, 5);
          }
          if (element._scrollAnimation) {
            cancelAnimationFrame(element._scrollAnimation);
          }
          element._scrollAnimation = requestAnimationFrame(animation);
        }
      });
    }
  });

  function checkSingleSection() {
    const allSections = layoutSection.querySelectorAll(
      ".product-page-description"
    );
    const hasOtherSections = Array.from(allSections).some((section, index) => {
      if (index === 0) return false;
      return section.offsetParent !== null;
    });
    const descriptionSection = layoutSection.querySelector(
      ".product-page-description"
    );
    if (descriptionSection) {
      descriptionSection.classList.toggle("single-section", !hasOtherSections);
    }
  }
  checkSingleSection();
});
